module.exports = __webpack_public_path__ + "static/media/marker-destination.e7cdacdb.png";